<template>
  <div class="cart">
    <h2>Service-Leistung</h2>
    <div class="cart-wrapper">
      <div class="content-wrapper">
        <div>
          <h3>Sie können unter folgenden Service-Leistungen auswählen:</h3>

          <div v-if="groupedServices.length != 0">
            <div v-for="(outerGroup, outerGroupIndex) in groupedServices" :key="outerGroupIndex">
              <div v-for="(innerGroup, innerGroupIndex) in outerGroup.innerGroups" :key="innerGroupIndex">
                <div v-for="(service, serviceIndex) in innerGroup.services" :key="serviceIndex">
                  <div class="card" v-if="outerGroup.innerGroups.length === 1">
                    <b-row align-v="center" :name="service">
                      <label :for="service.id" class="check-container">
                        <div class="card-body card-input">
                          <div class="card-title">
                            <div>
                              <b-checkbox v-if="innerGroup.selected.length !== 0" v-bind:id="service.id.toString()"
                                v-bind:value="service.id" v-bind:name="'grouped-' + service.id"
                                v-model="innerGroup.selected" onclick="return false" @change="
                                  changeInput(
                                    $event,
                                    service,
                                    outerGroupIndex,
                                    innerGroupIndex,
                                    serviceIndex
                                  )
                                " type="checkbox" class="customCheckbox" />
                              <b-checkbox v-else v-bind:id="service.id.toString()" v-bind:value="service.id"
                                v-bind:name="'grouped-' + service.id" v-model="innerGroup.selected" @change="
                                  changeInput(
                                    $event,
                                    service,
                                    outerGroupIndex,
                                    innerGroupIndex,
                                    serviceIndex
                                  )
                                " type="checkbox" class="customCheckbox" />
                            </div>
                            <div>
                              <h5 class="service-title margin-left-2rem">
                                {{ service.title }}
                              </h5>
                            </div>
                            <div>
                              <h5 class="service-price">
                                <template v-if="service.priceOnDemand">
                                  Auf Anfrage
                                </template>
                                <template v-else-if="service.priceRange">
                                  ab {{ service.price | currency }}
                                </template>
                                <template v-else>
                                  {{ service.price | currency }}
                                </template>
                              </h5>
                            </div>
                          </div>
                          <span v-if="service.info" class="card-text">
                            <p v-html="service.info"></p>
                          </span>
                        </div>
                      </label>
                    </b-row>
                  </div>

                  <div class="card" v-else>
                    <b-row align-v="center" :name="service">
                      <label :for="service.id" class="check-container">
                        <div class="card-body card-input">
                          <div class="card-title">
                            <div>
                              <b-checkbox v-if="innerGroup.selected.length !== 0" v-bind:id="service.id.toString()"
                                v-bind:value="service.id" v-bind:name="'grouped-' + service.id"
                                v-model="innerGroup.selected" onclick="return false" @change="
                                  changeInput(
                                    $event,
                                    service,
                                    outerGroupIndex,
                                    innerGroupIndex,
                                    serviceIndex
                                  )
                                " type="radio" class="custom-radio" />
                              <b-checkbox v-else v-bind:id="service.id.toString()" v-bind:value="service.id"
                                v-bind:name="'grouped-' + service.id" v-model="innerGroup.selected" @change="
                                  changeInput(
                                    $event,
                                    service,
                                    outerGroupIndex,
                                    innerGroupIndex,
                                    serviceIndex
                                  )
                                " type="radio" class="custom-radio" />
                            </div>
                            <div>
                              <h5 class="margin-left-2rem">
                                {{ service.title }}
                              </h5>
                            </div>
                            <div>
                              <h5 class="service-price">
                                <template v-if="service.priceOnDemand">
                                  Auf Anfrage
                                </template>
                                <template v-else-if="service.priceRange">
                                  ab {{ service.price | currency }}
                                </template>
                                <template v-else>
                                  {{ service.price | currency }}
                                </template>
                              </h5>
                            </div>
                          </div>
                          <p v-if="service.info" class="card-text">
                            {{ service.info }}
                          </p>
                        </div>
                      </label>
                    </b-row>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else>
            Wir konnten leider keine Service-Leistung für Sie ermitteln.
            Bitte versuchen Sie es erneut.
          </div>

          <div class="accordion" role="tablist">
            <b-card v-if="showWarranty" no-body class="garantie">
              <b-card-header header-tag="header" class="p-1" role="tab" id="garantie-header">
                <b-button block id="garantie-tab" v-b-toggle.accordion-1 variant="" class="text-left"
                  @click="toggleGarantieStyles()">
                  <span class="when-open">
                    <img src="@/assets/images/help-center/minus.svg" alt="Geschlossen" />
                  </span>
                  <span class="when-closed">
                    <img src="@/assets/images/help-center/plus_icon.svg" alt="Geoeffnet" />
                  </span>
                  <span>Anfrage auf Gewährleistung</span>
                </b-button>
              </b-card-header>
              <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <p>
                    Laden Sie bitte ein Foto von Ihrem Kaufbeleg (d.h. Rechnung oder Kassenbon - NICHT Lieferschein) hoch. Der
                    Kaufbeleg muss gut erkennbar sein.
                    <small>[Notwendig]</small>
                  </p>
                  <div class="image-upload-wrapper">
                    <input id="warranty-images" ref="warrantyImage" type="file" accept="image/*" style="opacity: 0"
                      multiple @change="uploadWarranty" />
                    <label for="warranty-images" class="image-input">
                      <span>Foto hochladen</span>
                      <span><img src="@/assets/images/upload-plus.svg" alt="upload-plus" /></span>
                    </label>
                  </div>
                  <div class="image-info">
                    <small>Laden Sie eine .png oder .jpg Datei hoch. Maximal
                      5MB</small>
                  </div>
                  <div v-if="warrantySizeError" class="invalid-feedback">
                    <div class="error">
                      Bitte laden Sie Bilder mit maximal 5MB hoch.
                    </div>
                  </div>
                  <div class="form-preview-images">
                    <div v-for="(image, index) in warrantyImage" :key="index" class="mr-3 mt-3">
                      <img :src="image.preview" class="img-fluid mh-100" />
                      <button type="button" class="btn btn-primary" @click="removeWarranty(index)">
                        <i class="fas fa-trash" />
                      </button>
                    </div>
                  </div>
                  <div v-if="hasError('images')" class="invalid-feedback d-block">
                    <div class="error">
                      Bitte fügen Sie mind. zwei jedoch nicht mehr als drei
                      Fotos hinzu.
                    </div>
                  </div>
                  <small v-if="
                    (watchProtectionImage.length == 0 ||
                      damageDescription == '' ||
                      damageDateDay == null ||
                      damageDateMonth == null ||
                      damageDateYear == null) &&
                    warrantyImage.length != 0
                  " style="margin-top: 16px">Da Garantie ausgewählt wurde, ist der Uhrenschutzbereich
                    deaktiviert.</small>
                  <b-button v-if="
                    (watchProtectionImage.length == 0 ||
                      damageDescription == '' ||
                      damageDateDay == null ||
                      damageDateMonth == null ||
                      damageDateYear == null) &&
                    warrantyImage.length != 0
                  " variant="danger" @click="clear()">
                    Zurücksetzen
                  </b-button>
                </b-card-body>
              </b-collapse>
            </b-card>

            <b-card no-body class="uhrenschutz" v-if="
              this.$store.state.questions[
                this.$store.state.questions.length - 1
              ].selectedAnswers == 'uhr' && warrantyImage.length == 0
            ">
              <b-card-header header-tag="header" class="p-1" role="tab" id="uhrenschutz-header">
                <b-button block v-b-toggle.accordion-2 variant="" class="text-left" id="uhrenschutz-tab"
                  @click="toggleUhrenschutzStyles()">
                  <span class="when-open">
                    <img src="@/assets/images/help-center/minus.svg" alt="Geschlossen" />
                  </span>
                  <span class="when-closed">
                    <img src="@/assets/images/help-center/plus_icon.svg" alt="Geoeffnet" />
                  </span>
                  <span>Uhrenschutz</span>
                </b-button>
              </b-card-header>
              <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <p class="watch-protection-intro">
                    Unsere Uhrmacher prüfen, ob es sich um ein Uhrenschutz
                    Schadenfall handelt. Bitte hinterlegen Sie folgende Daten:
                  </p>
                  <label>
                    <strong>Datum des Schadenfalls </strong>
                  </label>
                  <div class="date-wrapper">
                    <b-form-select id="damageDate" type="date" v-model="damageDateDay" :options="dayOptions"
                      @change="handleForwardButton()">
                      <template #first>
                        <option :value="null">Tag</option>
                      </template>
                    </b-form-select>
                    <b-form-select id="damageMonth" type="date" v-model="damageDateMonth" :options="monthOptions" @change="
                      setDateOptions();
                    handleForwardButton();
                                            ">
                      <template #first>
                        <option :value="null">Monat</option>
                      </template>
                    </b-form-select>
                    <b-form-select id="damageYear" type="date" v-model="damageDateYear" :options="yearOptions" @change="
                      setDateOptions();
                    handleForwardButton();
                                            ">
                      <template #first>
                        <option :value="null">Jahr</option>
                      </template>
                    </b-form-select>
                  </div>
                  <div class="damageDescription">
                    <float-label>
                      <textarea id="damageDescription" v-model="damageDescription"
                        placeholder="Schildern Sie bitte, wie der Schaden entstanden ist."
                        @change="handleForwardButton()">
                        </textarea>
                    </float-label>
                  </div>

                  <p>
                    Laden Sie bitte ein Foto von Ihrem Kaufbeleg (d.h. Rechnung oder Kassenbon - NICHT Lieferschein) hoch. Der
                    Kaufbeleg muss gut erkennbar sein.
                    <small>[Notwendig]</small>
                  </p>
                  <div class="image-upload-wrapper">
                    <input id="watch-protection-images" ref="watchProtectionImage" type="file" accept="image/*"
                      style="opacity: 0" multiple @change="uploadWatchProtection" />
                    <label for="watch-protection-images" class="image-input">
                      <span>Foto hochladen</span>
                      <span><img src="@/assets/images/upload-plus.svg" alt="upload-plus" /></span>
                    </label>
                  </div>
                  <div class="image-info">
                    <small>Laden Sie eine .png oder .jpg Datei hoch. Maximal
                      5MB</small>
                  </div>
                  <div v-if="protectionSizeError" class="invalid-feedback">
                    <div class="error">
                      Bitte laden Sie Bilder mit maximal 5MB hoch.
                    </div>
                  </div>
                  <div class="form-preview-images">
                    <div v-for="(image, index) in watchProtectionImage" :key="index" class="mr-3 mt-3">
                      <img :src="image.preview" class="img-fluid mh-100" />
                      <button type="button" class="btn btn-primary" @click="removeWatchProtection(index)">
                        <i class="fas fa-trash" />
                      </button>
                    </div>
                  </div>
                  <div v-if="hasError('images')" class="invalid-feedback d-block">
                    <div class="error">
                      Bitte fügen Sie mind. zwei jedoch nicht mehr als drei
                      Fotos hinzu.
                    </div>
                  </div>
                  <small v-if="
                    (watchProtectionImage.length != 0 ||
                      damageDescription != '' ||
                      damageDateDay != null ||
                      damageDateMonth != null ||
                      damageDateYear != null) &&
                    this.warrantyImage.length == 0
                  " style="margin-top: 16px">
                    Da Uhrenschutz ausgewählt wurde, ist der Garantiebereich
                    deaktiviert.
                  </small>
                  <b-button v-if="
                    (watchProtectionImage.length != 0 ||
                      damageDescription != '' ||
                      damageDateDay != null ||
                      damageDateMonth != null ||
                      damageDateYear != null) &&
                    this.warrantyImage.length == 0
                  " variant="danger" @click="clear()">
                    Zurücksetzen
                  </b-button>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 cart-navigation">
      <button class="btn btn-primary mt-3 shadow-none" @click="backToDiagnosis()" id="backToDiagnosis">
        Zurück
      </button>
      <button v-if="this.groupedServices.length != 0" :disabled="disableCheckout" class="btn btn-primary mt-3 shadow-none"
        @click="store" id="toCheckout">
        Weiter
      </button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";

export default {
  name: "Cart",
  component: {},
  data() {
    return {
      groupedServices: [],
      warrantyImage: [],
      watchProtectionImage: [],
      orderProtectionInfo: {},
      damageDateDay: null,
      damageDateMonth: null,
      damageDateYear: null,
      damageLocation: "",
      damageCulprit: "",
      damageEvent: "",
      damageDescription: "",
      dayOptions: [],
      monthOptions: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
      ],
      yearOptions: [],
      oddMonths: ["1", "3", "5", "7", "8", "10", "12"],
      evenMonths: ["4", "6", "9", "11"],
      warrantySizeError: false,
      protectionSizeError: false,
      disableCheckout: false,
    };
  },
  mounted() {
    this.removeIncludedServices()
    this.groupedServices = this.create();
    for (let number = new Date().getFullYear(); number >= 2000; number--) {
      this.yearOptions.push(number.toString());
    }
    this.setDateOptions();
    this.$store.commit("setCurrentStep", "0");
    if (this.$store.state.orderProtectionInfo != {}) {
      this.orderProtectionInfo = this.$store.state.orderProtectionInfo;
      if (this.orderProtectionInfo.damageDate) {
        let dates = this.orderProtectionInfo.damageDate.split("-");
        this.damageDateDay = dates[2];
        this.damageDateMonth = dates[1];
        this.damageDateYear = dates[0];
      }
      if (this.orderProtectionInfo.damageDescription) {
        this.damageDescription = this.orderProtectionInfo.damageDescription;
      }
    }
  },
  methods: {
    removeIncludedServices() {
      const repairServices = this.$store.state.repairServices;
      let includedServices = [];
      repairServices.forEach(e => {
        if (e.includedServices !== undefined && e.includedServices !== null) {
          let elements = e.includedServices.split(",")
          elements.forEach(toAdd => {
            if (!includedServices.includes(Number(toAdd)))
              includedServices.push(Number(toAdd));
          })
        }
      })

      let filteredServices = [];
      repairServices.forEach(element => {
        if (!includedServices.includes(element.id))
          filteredServices.push(element);
      });

      this.$store.commit('setRepairServices', filteredServices);
    },
    create() {
      if (
        this.$store.state.warrantyImage != null &&
        this.$store.state.warrantyImage.length !== 0
      )
        this.warrantyImage = this.$store.state.warrantyImage;

      if (
        this.$store.state.watchProtectionImage != null &&
        this.$store.state.watchProtectionImage.length !== 0
      )
        this.watchProtectionImage = this.$store.state.watchProtectionImage;

      const repairServices = this.$store.state.repairServices;
      const outerGroupElements = _.chain(repairServices)
        .groupBy("condition")
        .map((value, key) => ({ condition: key, services: value }))
        .value();

      let outerGroups = [];
      outerGroupElements.forEach(function (key) {
        let outerGroupEntry = {
          condition: key.condition,
          innerGroups: [],
        };

        const innerGroups = _.chain(key.services)
          .groupBy("groupNo")
          .map((value, key) => ({
            groupNo: key,
            selected: null,
            services: value,
          }))
          .value();

        outerGroupEntry.innerGroups = innerGroups;
        let index = 0;
        outerGroupEntry.innerGroups.forEach((innerGroupEntry) => {
          if (index === 0) {
            innerGroupEntry.selected = [];
            innerGroupEntry.services.forEach((s) => {
              innerGroupEntry.selected.push(s.id);
            });
          } else {
            innerGroupEntry.selected = [];
          }

          index++;
        });

        outerGroups.push(outerGroupEntry);
      });

      this.orderProtectionInfo = this.$store.state.orderProtectionInfo;

      return outerGroups;
    },
    clear() {
      this.watchProtectionImage = [];
      this.warrantyImage = [];
      this.damageDescription = '';
      this.damageDateDay = null;
      this.damageDateMonth = null;
      this.damageDateYear = null;
      this.damageLocation = "";
      this.damageCulprit = "";
      this.damageEvent = "";
      this.damageDescription = "";
      this.disableCheckout = false;
      this.$store.commit("setWarrantyImage", []);
      this.$store.commit("setWatchProtectionImage", []);
      this.$store.commit("setOrderProtectionInfo", {});
      this.$store.state.selectedRepairServices.forEach((service) => {
        if (service.backup !== null && service.backup !== undefined) {
          service.price = service.backup;
        } else {
          service.price = null;
        }
        if (service.backupDuration !== null && service.backupDuration !== undefined) {
          service.duration = service.durationBackup;
        } else {
          service.duration = null;
        }
      });
      this.$store.commit("setWatchProtectionPriceIsCalculated", false);
      this.$store.commit("setWarrantyPriceIsCalculated", false);
    },
    backToDiagnosis() {
      this.clear()
      this.$router.push({ name: "Diagnosis" })
        .catch(error => {
          console.log(error);
        });
    },
    handleForwardButton() {
      if (
        this.damageDescription != "" ||
        this.damageDateDay != null ||
        this.damageDateMonth != null ||
        this.damageDateYear != null
      ) {
        if (this.watchProtectionImage.length != 0) {
          this.disableCheckout = false;
        } else {
          this.disableCheckout = true;
        }
      } else if (this.groupedServices.length != 0) {
        this.disableCheckout = false;
      } else {
        this.disableCheckout = true;
      }
    },
    uploadWarranty(event) {
      for (const image of event.target.files) {
        try {
          if (image.type.includes("image/png") ||
            image.type.includes("image/jpeg") ||
            image.type.includes("image/gif") ||
            image.name.includes("image/heic") ||
            image.type.includes("image/webp") ||
            image.name.includes("image/heif")) {
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = (e) => {
              image.preview = e.target.result;
              if (image.size < 5243000) {
                this.warrantySizeError = false;
                this.warrantyImage.push(image);
                this.watchProtectionImage = [];
                this.orderProtectionInfo = {};
                this.damageDate = "";
                this.damageDescription = "";
                this.damageDateDay = null;
                this.damageDateMonth = null;
                this.damageDateYear = null;
              } else {
                this.warrantySizeError = true;
              }
            };
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    uploadWatchProtection(event) {
      for (const image of event.target.files) {
        try {
          if (image.type.includes("image/png") ||
            image.type.includes("image/jpeg") ||
            image.type.includes("image/gif") ||
            image.name.includes("image/heic") ||
            image.type.includes("image/webp") ||
            image.name.includes("image/heif")) {
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = (e) => {
              image.preview = e.target.result;
              if (image.size < 5243000) {
                this.protectionSizeError = false;
                this.watchProtectionImage.push(image);
                this.warrantyImage = [];
                this.handleForwardButton();
              } else {
                this.protectionSizeError = true;
              }
            };
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    removeWatchProtection(index) {
      this.watchProtectionImage.splice(index, 1);
      this.$refs.watchProtectionImage.value = null;
      this.handleForwardButton();
    },
    removeWarranty(index) {
      this.warrantyImage.splice(index, 1);
      this.$refs.warrantyImage.value = null;
    },
    hasError(fieldName) {
      return false;
    },
    changeInput(
      event,
      selectedService,
      outerGroupIndex,
      innerGroupIndex,
      serviceIndex
    ) {
      let outerGroup = this.groupedServices[outerGroupIndex];
      outerGroup.innerGroups.forEach((innerGroup) => {
        Vue.set(innerGroup, "selected", []);
      });

      Vue.set(
        outerGroup.innerGroups[innerGroupIndex],
        "selected",
        outerGroup.innerGroups[innerGroupIndex].services.map((x) => x.id)
      );
      this.$forceUpdate();
    },
    store() {
      let toStore = [];
      this.groupedServices.forEach((outerGroup) => {
        outerGroup.innerGroups.forEach((innerGroup) => {
          if (innerGroup.selected.length !== 0) {
            innerGroup.selected.forEach((s) => {
              let toPush = this.$store.state.repairServices.find(
                (service) => service.id === s
              );
              toStore.push(toPush);
            });
          }
        });
      });

      if (
        this.watchProtectionImage &&
        this.watchProtectionImage.length != 0 &&
        this.warrantyImage.length == 0
      ) {
        this.$store.commit(
          "setWatchProtectionImage",
          this.watchProtectionImage
        );

        if (this.orderProtectionInfo) {
          this.orderProtectionInfo = {
            damageDate:
              this.damageDateYear +
              "-" +
              this.damageDateMonth +
              "-" +
              this.damageDateDay,
            damageDescription: this.damageDescription,
          };
        }
      }
      if (this.orderProtectionInfo) {
        if (this.watchProtectionImage.length < 1) {
          this.$store.commit("setOrderProtectionInfo", {});
        } else {
          this.$store.commit(
            "setOrderProtectionInfo",
            this.orderProtectionInfo
          );
        }
      }

      if (this.warrantyImage && this.warrantyImage.length != 0) {
        this.$store.commit("setWarrantyImage", this.warrantyImage);
      }

      this.$store.commit("setSelectedRepairServices", toStore);
      this.$router.push({ name: "ConditionCheck" })
        .catch(error => {
          console.log(error);
        });
    },
    toggleGarantieStyles() {
      if (!document.getElementById("garantie-tab").__BV_toggle_STATE__) {
        document.getElementById("garantie-header").style.background = "#f0f0f0";
        if (document.getElementById("uhrenschutz-header") != null)
          document.getElementById("uhrenschutz-header").style.background = "transparent";
      } else {
        document.getElementById("garantie-header").style.background =
          "transparent";
      }
    },
    toggleUhrenschutzStyles() {
      if (!document.getElementById("uhrenschutz-tab").__BV_toggle_STATE__) {
        document.getElementById("uhrenschutz-header").style.background =
          "#f0f0f0";
        if (document.getElementById("garantie-header") != null)
          document.getElementById("garantie-header").style.background = "transparent";
      } else {
        document.getElementById("uhrenschutz-header").style.background =
          "transparent";
      }
    },
    setDateOptions() {
      let tempYear = parseInt(this.damageDateYear);
      if (this.damageDateMonth === null) {
        for (let day = 1; day <= 31; day++) {
          this.dayOptions.push(day.toString());
        }
      } else if (this.damageDateMonth === "2") {
        this.dayOptions = [];
        if (this.damageDateYear === null) {
          for (let day = 1; day <= 28; day++) {
            this.dayOptions.push(day.toString());
          }
        } else if (tempYear % 100 === 0 && tempYear % 400 !== 0) {
          for (let day = 1; day <= 28; day++) {
            this.dayOptions.push(day.toString());
          }
        } else if (
          (tempYear % 4 === 0 && tempYear & (100 !== 0)) ||
          tempYear % 400 === 0
        ) {
          for (let day = 1; day <= 29; day++) {
            this.dayOptions.push(day.toString());
          }
        } else {
          for (let day = 1; day <= 28; day++) {
            this.dayOptions.push(day.toString());
          }
        }
      } else if (this.oddMonths.includes(this.damageDateMonth)) {
        this.dayOptions = [];
        for (let day = 1; day <= 31; day++) {
          this.dayOptions.push(day.toString());
        }
      } else if (this.evenMonths.includes(this.damageDateMonth)) {
        this.dayOptions = [];
        for (let day = 1; day <= 30; day++) {
          this.dayOptions.push(day.toString());
        }
      }
    },
  },
  computed: {
    showWarranty() {
      const isWarranty = this.watchProtectionImage.length === 0
        && this.damageDescription === ''
        && this.damageDateDay == null
        && this.damageDateMonth == null
        && this.damageDateYear == null
        && this.$store.getters.isClock;

      return isWarranty;
    }
  }
};
</script>
